import React from 'react';
import { Layout, Header, Loader, Menu } from 'elmo-elements';
import type { TPageLoaderProps } from './types';

export const PageLoader = (props: TPageLoaderProps) => {
    const { withMenu = false } = props;
    return (
        <Layout menu={withMenu && <Menu logo={null} isLoading />}>
            <Layout.Header>
                <Header title={<Loader type="text" viewBoxHeight={40} viewBoxWidth={300} />} />
            </Layout.Header>
            <Layout.Content>
                <Loader type="content" className="my-4" height={200} width={600} />
            </Layout.Content>
        </Layout>
    );
};
